export default __webpack_public_path__ + "static/media/intro_img3.2e28538e.png";